import { Injectable } from '@angular/core';

import {
  ControlValidator,
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError
} from '../../types/validator.types';

@Injectable()
export class DigitalRangeValidator extends ControlValidator {
  type = ControlValidatorType.DigitalRange;
  validateMoment = ControlValidateMoment.Input;

  validate(): ControlValidatorError {
    this.error = new ControlValidatorError(false, '');

    const max = <number>this.model.max;
    let min = <number>this.model.min;

    if (isNaN(min)) {
      min = 0;
    }
    let message = 'è¯·è¾å¥' + min + '-' + max + 'ä¹é´çæ°å­';
    if (isNaN(max)) {
      message = 'è¯·è¾å¥å¤§äºç­äº' + min + 'çæ°å­';
    }

    const valid = this.isValid(min, max);
    if (!valid) {
      this.error.message = message;
      this.error.success = false;
    } else {
      this.error = new ControlValidatorError(true, '');
    }
    return this.error;
  }

  private isValid(min: number, max: number): boolean {
    const value = this.control.model.value;
    // å¼æ¯ç©º  åéè¿ ç­äº0åæ¯è¦å¤æ­
    if (value !== 0 && !value) {
      return true;
    }
    if (isNaN(max)) {
      if (min <= value) {
        return true;
      }
    }
    if (min <= value && value <= max) {
      return true;
    }
    return false;
  }
}
